import { type ComponentProps } from 'react'
import { Combobox } from '@base-ui/react/combobox'
import { twMerge } from 'tailwind-merge'
import { ChevronDown } from 'lucide-react'
import type { PartProps } from '../../../lib/part-props'

interface ComboboxTriggerProps extends PartProps<ComponentProps<typeof Combobox.Trigger>> {
  className?: string
}

function ComboboxTrigger({ className, children, ...props }: ComboboxTriggerProps) {
  return (
    <Combobox.Trigger
      className={twMerge(
        'text-foreground-secondary hover:text-foreground corner-smooth flex h-6 w-6 items-center justify-center rounded bg-transparent p-0 transition-colors',
        className,
      )}
      {...props}
    >
      {children || <ChevronDown className="size-4" />}
    </Combobox.Trigger>
  )
}

export { ComboboxTrigger }
